import 'css-chunksrc/client/scenes/listEdition/listEditionForm/textInput/styles.scss';export default {
  "textInput": "_textInput_1w3xg_1",
  "invalidTextInput": "_invalidTextInput_1w3xg_22"
};